// import Footer from "./Footer";
import BlogSection from "./BlogSection";
import HomeTestimonials from "./HomeTestimonials";
import PortfolioGallery from "./PortfolioGallery";
import ScrollAnimationGallery from "./ScrollAnimationGallery";
import SkillsSection from "./SkillsSection";
import WhatCanWeDoForYouSection from "./WhatCanWeDoForYouSection";
import WhyChooseUs from "./WhyChooseUs";
import CreativeAgenc from "./CreativeAgenc";
import InfiniteLogoCarousel from "./InfiniteLogoCarousel";
import StatsSection from "./StatsSection";
// import DesignProcess from "./DesignProcess";
import ServicesSection from "./ServicesSection";
import WebDesignAgencySection from "./WebDesignAgencySection";
import FAQSection from "./FAQSection";
import HeroSection from "./HeroSection";
import GamingHeroSection from "./GamingHeroSection";
import GamingShowcase from "./GamingShowcase";
import VisualBusinessJourney from "./VisualBusinessJourney";
import VisualProcess from "./VisualProcess";
import FeaturedVideo from "./FeaturedVideo";
import AIServices from "./AIServices";
import DigitalIdentitySection from "./DigitalIdentitySection";

function Homepage() {
    return (
        <div className="Homepage">
            <HeroSection />
            <ScrollAnimationGallery />
            <AIServices />
            <DigitalIdentitySection />
            <CreativeAgenc />
            <GamingShowcase />
            <VisualBusinessJourney />
            {/* <FeaturedVideo /> */}
            <WhatCanWeDoForYouSection />
            <SkillsSection />
            <VisualProcess />
            <WebDesignAgencySection />
            <ServicesSection />
            <InfiniteLogoCarousel />
            <StatsSection />
            {/* <DesignProcess /> */}
            <WhyChooseUs />
            <GamingHeroSection />
            {/* <HomeTestimonials /> */}
            {/* <PortfolioGallery /> */}
            {/* <BlogSection /> */}
            <FAQSection />

        </div>
    );
}

export default Homepage;
